import type { Registratie } from '@/types/domain';

export type Validatiefouten = Partial<Record<string, string>>;

const EMAIL_PATROON = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * Controleert het formulier vóór opslaan.
 *
 * De AVG-regel is bewust hard: persoonsgegevens mogen alleen worden vastgelegd
 * als de bewoner daar expliciet toestemming voor heeft gegeven.
 */
export function valideer(registratie: Registratie): Validatiefouten {
  const fouten: Validatiefouten = {};

  if (registratie.contactmomenten.length === 0) {
    fouten.contact = 'Er moet minstens één contactmoment zijn.';
  }

  const onvolledig = registratie.contactmomenten.find(
    (moment) => !moment.datum || !moment.coach.trim()
  );
  if (onvolledig) {
    fouten.contact = 'Vul bij elk contactmoment een datum en een coach in.';
  }

  const { bewoner } = registratie;
  const heeftPersoonsgegevens = Boolean(
    bewoner.naam.trim() || bewoner.telefoon.trim() || bewoner.email.trim()
  );

  if (heeftPersoonsgegevens && !bewoner.toestemmingPersoonsgegevens) {
    fouten.toestemming =
      'Er zijn persoonsgegevens ingevuld. Vink de toestemming aan of wis de gegevens.';
  }

  if (bewoner.email.trim() && !EMAIL_PATROON.test(bewoner.email.trim())) {
    fouten.email = 'Dit lijkt geen geldig e-mailadres.';
  }

  for (const [veld, tuin] of [
    ['bergingVoortuin', registratie.voortuin],
    ['bergingAchtertuin', registratie.achtertuin],
  ] as const) {
    const berging = tuin.bergingM3;
    if (berging !== null && (berging < 0 || berging > 500)) {
      fouten[veld] = 'Vul een berging tussen 0 en 500 m³ in.';
    }
  }

  return fouten;
}

export function heeftFouten(fouten: Validatiefouten): boolean {
  return Object.keys(fouten).length > 0;
}
